<template>
  <div class="sticky-top bg-dark text-white header">
    <div class="container vap-section d-flex justify-content-between pt-3 pb-2">
      <NuxtLink to="/"
        ><div>
          <svg
            viewBox="0 0 260 120"
            width="128"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use fill="white" href="../assets/svg/vap-logo.svg#logo" />
          </svg></div
      ></NuxtLink>
      <div
        class="d-flex align-items-center"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasRight"
        aria-controls="offcanvasRight"
        @click="toggleOffcanvas"
      >
        <div id="nav-icon3" :class="[offcanvasActive ? 'open' : '']">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <!-- <svg
          v-if="!offcanvasActive"
          viewBox="0 0 16 16"
          width="42"
          xmlns="http://www.w3.org/2000/svg"
        >
          <use fill="white" href="../assets/svg/list.svg#list" />
        </svg>
        <svg
          v-else
          viewBox="0 0 16 16"
          width="36"
          xmlns="http://www.w3.org/2000/svg"
        >
          <use fill="white" href="../assets/svg/x-lg.svg#x-lg" />
        </svg> -->
      </div>
    </div>
  </div>

  <div
    class="offcanvas offcanvas-end bg-dark text-white"
    tabindex="-1"
    id="offcanvasRight"
    aria-labelledby="offcanvasRightLabel"
    data-bs-backdrop="false"
  >
    <!-- <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasRightLabel"></h5>
      <div
        class="d-flex pt-2"
        type="button"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      >
        <svg viewBox="0 0 16 16" width="36" xmlns="http://www.w3.org/2000/svg">
          <use fill="white" href="../assets/svg/x-lg.svg#x-lg" />
        </svg>
      </div>
    </div> -->
    <div class="offcanvas-body pt-5 ps-5">
      <div data-bs-dismiss="offcanvas" aria-label="Close">
        <NuxtLink to="/podcast"
          ><h1 :class="{ 'menu-active': podcastActive }" class="text-white">
            Podcast
          </h1></NuxtLink
        >
      </div>

      <div data-bs-dismiss="offcanvas" aria-label="Close">
        <NuxtLink to="/hoerbuch"
          ><h1 :class="{ 'menu-active': hoerbuchActive }" class="text-white">
            Hörbuch & Hörspiel
          </h1></NuxtLink
        >
      </div>

      <div data-bs-dismiss="offcanvas" aria-label="Close">
        <NuxtLink to="/story"
          ><h1 :class="{ 'menu-active': storyActive }" class="text-white">
            Unsere Story
          </h1></NuxtLink
        >
      </div>
    </div>
  </div>
</template>

<script setup>
const offcanvasActive = ref(false);
const router = useRouter();
const currentRoute = router.currentRoute.value.path;
const podcastActive = computed(() => {
  return currentRoute == "/podcast" ? true : false;
});

const hoerbuchActive = computed(() => {
  return currentRoute == "/hoerbuch" ? true : false;
});

const storyActive = computed(() => {
  return currentRoute == "/story" ? true : false;
});

const toggleOffcanvas = () => {
  offcanvasActive.value = !offcanvasActive.value;
};
</script>

<style scoped>
.header {
  border-bottom: 1px solid rgb(57, 57, 57);
}

h1 {
  font-weight: 900;
  font-size: xx-large;
  padding-bottom: 1.5rem;
}
.menu-active {
  color: #fc4667 !important;
  /* padding-bottom: 4px;
  border-bottom: 2px solid #fc4667; */
}

.offcanvas {
  margin-top: 84px !important;
  /* height: 91vh !important; */
  width: 100% !important;
  height: 100% !important;
}

.offcanvas.offcanvas-end {
  border-left: none;
}

#nav-icon1,
#nav-icon2,
#nav-icon3,
#nav-icon4 {
  width: 38px;
  height: 32px;
  position: relative;
  /* margin: 50px auto; */
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -o-transition: 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
  cursor: pointer;
}

#nav-icon1 span,
#nav-icon3 span,
#nav-icon4 span {
  display: block;
  position: absolute;
  height: 2px;
  width: 100%;
  background: white;
  border-radius: 4px;
  opacity: 1;
  left: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.25s ease-in-out;
  -moz-transition: 0.25s ease-in-out;
  -o-transition: 0.25s ease-in-out;
  transition: 0.25s ease-in-out;
}

#nav-icon3 span:nth-child(1) {
  top: 0px;
}

#nav-icon3 span:nth-child(2),
#nav-icon3 span:nth-child(3) {
  top: 12px;
}

#nav-icon3 span:nth-child(4) {
  top: 24px;
}

#nav-icon3.open span:nth-child(1) {
  top: 18px;
  width: 0%;
  left: 50%;
}

#nav-icon3.open span:nth-child(2) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

#nav-icon3.open span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

#nav-icon3.open span:nth-child(4) {
  top: 18px;
  width: 0%;
  left: 50%;
}
</style>
